export default __webpack_public_path__ + "static/media/gif.154b99f7.svg";